// extracted by mini-css-extract-plugin
export default {"defaultImage":"Image_defaultImage__l-bib","imageContainer":"Image_imageContainer__msbY3"};